import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const NavbarContext = createContext();

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error('useNavbar must be used within NavbarProvider');
  }
  return context;
};

export const NavbarProvider = ({ children }) => {
  const [variant, setVariant] = useState('dark');

  return (
    <NavbarContext.Provider value={{ variant, setVariant }}>
      {children}
    </NavbarContext.Provider>
  );
};

NavbarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};